export const IMPORT_MANIFEST_CONTEXTS = [
    {
        label: 'Products',
        title: 'Product import',
        manifestType: 'product_import',
        ownerContext: 'product',
    },
    {
        label: 'Suppliers',
        title: 'Supplier import',
        manifestType: 'supplier_import',
        ownerContext: 'supply_chain',
    },
]

export const getImportManifestContext = manifestType => (
    IMPORT_MANIFEST_CONTEXTS.find(context => context.manifestType === manifestType) || null
)

export const getImportManifestTitle = manifestType => {
    const context = getImportManifestContext(manifestType)
    return context ? context.title : manifestType
}
